export default "__VITE_ASSET__D_UoF2Ym__"